import { render, staticRenderFns } from "./AddressBookFilter.vue?vue&type=template&id=81e2911a"
import script from "./AddressBookFilter.vue?vue&type=script&lang=js"
export * from "./AddressBookFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports